import _camelcaseKeys from 'camelcase-keys'

export const camelizeKeys = <T extends Record<string, unknown> | ReadonlyArray<Record<string, unknown>>>(val: T) =>
  _camelcaseKeys(val, {
    deep: true,
    exclude: [
      /**
       * we have to exclude dates, otherwise we'll get "20240606"
       * instead of "2024-06-06"
       */
      /^\d{4}-\d{2}-\d{2}$/,
    ],
  })
